import { MapTo } from '@adobe/aem-react-editable-components';
import ProductPageBenefitsCard, { ProductPageBenefitsCardEditConfig } from './ProductPageBenefitsCard';

export default MapTo('cob-corp-acquisition/components/creditonebank/product-page-benefits-card')(ProductPageBenefitsCard, ProductPageBenefitsCardEditConfig);